import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
        name: 'libcastUrl'
      })
export class LibcastUrlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: string, args?: any): any {
    return this.libcastUrl(value);
  }

  libcastUrl(url: string) {
    return this.sanitizeUrl(url.replace(/^https:\/\//i, '//') + '#api');
  }

  sanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
